export function isAmountBetweenThreshold(amount, secondAmount, threshold){
    const subtractValue = amount - secondAmount
    if (subtractValue === 0) {
        return true
    }
    const percentage = Math.abs(subtractValue / secondAmount * 100)
    return percentage <= threshold
}